import { connect } from 'react-redux';
import { createSelector, createStructuredSelector } from 'reselect';
import { personalizationSelector } from 'viewModel/selectors/personalization/personalizationSelector';
import { coreUserDataSelector } from 'viewModel/selectors/user/coreUserDataSelector';
import FrameworkUtils from 'utils/framework';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import PromotionListForYouHandlerEN from 'components/Content/PromotionListHandler/PromotionListForYouHandler/locales/PromotionListForYouHandler_en_US';
import PromotionListForYouHandlerFR from 'components/Content/PromotionListHandler/PromotionListForYouHandler/locales/PromotionListForYouHandler_fr_CA';
import Empty from 'constants/empty';
import Location from 'utils/Location';

const { wrapHOC } = FrameworkUtils;
const { getTextFromResource, getLocalisedDataFromResource } = LanguageLocaleUtils;

const getText = getLocalisedDataFromResource(PromotionListForYouHandlerEN, PromotionListForYouHandlerFR);

const fields = createSelector(
    coreUserDataSelector,
    personalizationSelector,
    (_state, ownProps) => ownProps.personalization,
    (_state, ownProps) => ownProps.title,
    (_state, ownProps) => ownProps.isNBOEnabled,
    createStructuredSelector({
        forYouTitle: getTextFromResource(getText, 'forYou')
    }),
    (user, personalization, componentPersonalization, cmsTitle, isNBOEnabled, textResources) => {
        const { personalizedComponent, isPersonalizationInitializing } = personalization;
        const personalizedItems = personalizedComponent?.variationData?.items || Empty.Array;
        const isSYSPage = Location.isShopMyStorePage() || Location.isShopSameDayPage();

        const isTrendingActiveForAnon =
            user.isAnonymous && Sephora.configurationSettings?.p13ntrendingNBO?.isEnabled && componentPersonalization?.isTrendingOffersEnabled;

        if (isTrendingActiveForAnon) {
            return {
                showFallback: personalizedItems.length === 0 && !Location.isHomepage(),
                showSkeleton: !Sephora.isSEO && isPersonalizationInitializing
            };
        }

        if (Location.isHomepage() || isSYSPage) {
            if (user.isAnonymous) {
                return {
                    showFallback: false
                };
            }

            if (!isNBOEnabled || personalizedItems.length === 0) {
                return {
                    showFallback: false,
                    title: cmsTitle
                };
            }
        }

        // Personalization is disabled (or not configured) — render CMS title/content and not show the personalized fallback UI.
        if (!user.isAnonymous && !componentPersonalization?.isEnabled) {
            return {
                showFallback: false,
                title: cmsTitle
            };
        }

        const title = `${textResources.forYouTitle}, ${user.firstName} ❤️`;
        // For SEO: never show skeleton - render content immediately
        const showSkeleton = !Sephora.isSEO && isPersonalizationInitializing;
        const showFallback =
            showSkeleton || // skeletonScreen
            user.isAnonymous || // signInScreen
            (!showSkeleton && (personalizedItems || [])?.length === 0); // fallBackScreen

        return {
            user,
            showSkeleton,
            showFallback,
            items: personalizedItems,
            title
        };
    }
);

const withPromotionListForYouHandlerProps = wrapHOC(connect(fields));

export {
    fields, withPromotionListForYouHandlerProps
};
